const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const perusahaan = () => import(/* webpackPrefetch: true */ '@/views/private/perusahaan/index.vue')
const banner_internal = () => import(/* webpackPrefetch: true */ '@/views/private/banner/index.vue')
const perusahaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/perusahaan/_id.vue')
const outlet = () => import(/* webpackPrefetch: true */ '@/views/private/outlet/index.vue')
const outlet_detail = () => import(/* webpackPrefetch: true */ '@/views/private/outlet/_id.vue')
const jenis_usaha = () => import(/* webpackPrefetch: true */ '@/views/private/jenis-usaha/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')
const pilit_outlet = () => import(/* webpackPrefetch: true */ '@/views/private/pilih-outlet/index.vue')
const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/edit/_id.vue')

const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')


const member = () => import(/* webpackPrefetch: true */ '@/views/private/member/index.vue')
const member_detail = () => import(/* webpackPrefetch: true */ '@/views/private/member/_id.vue')


const master_pembelian = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian.vue')
const master_pembelian_kategori_item = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/kategori-item/index.vue')
const master_pembelian_item = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/item/index.vue')
const master_pembelian_item_add = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/item/add/index.vue')
const master_pembelian_item_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/item/edit/_id.vue')
const master_pembelian_item_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/item/_id.vue')
const master_pembelian_supplier = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier/index.vue')
const master_pembelian_supplier_add = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier/add/index.vue')
const master_pembelian_supplier_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier/edit/_id.vue')
const master_pembelian_supplier_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier/_id.vue')
const master_pembelian_supplier_item = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier-item/index.vue')
const master_pembelian_supplier_item_add = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier-item/add/index.vue')
const master_pembelian_supplier_item_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier-item/edit/_id.vue')
const master_pembelian_supplier_item_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/supplier-item/_id.vue')
const master_pembelian_lokasi = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/lokasi/index.vue')
const master_pembelian_lokasi_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/lokasi/_id.vue')
const master_pembelian_lokasi_adit = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/lokasi/edit/_id.vue')
const master_pembelian_lokasi_add = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/lokasi/add/index.vue')
const master_pembelian_satuan = () => import(/* webpackPrefetch: true */ '@/views/private/master-pembelian/satuan/index.vue')

const pembelian = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian.vue')
const pembelian_permintaan = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan/index.vue')
const pembelian_permintaan_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan/add/index.vue')
const pembelian_permintaan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan/edit/_id.vue')
const pembelian_permintaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan/_id.vue')
const pembelian_permintaan_add_item = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan/add_item/_id.vue')
const pembelian_pengadaan = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/index.vue')
const pembelian_pengadaan_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/add/index.vue')
const pembelian_pengadaan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/edit/_id.vue')
const pembelian_pengadaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/_id.vue')
const pembelian_pengadaan_add_item = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/add_item/_id.vue')
const pembelian_pengadaan_invoice = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/pengadaan/invoice/_id.vue')
const pembelian_penerimaan = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/penerimaan/index.vue')
const pembelian_penerimaan_add_item = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/penerimaan/add_item/_id.vue')
const pembelian_penerimaan_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/penerimaan/add/index.vue')
const pembelian_penerimaan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/penerimaan/edit/_id.vue')
const pembelian_penerimaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/penerimaan/_id.vue')
const pembelian_persediaan = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/persediaan/index.vue')
const pembelian_persediaan_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/persediaan/add/index.vue')
const pembelian_persediaan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/persediaan/edit/_id.vue')
const pembelian_persediaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/persediaan/_id.vue')
const pembelian_approval_permintaan = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/approval-permintaan/index.vue')
const pembelian_approval_permintaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/approval-permintaan/_id.vue')

const master_penjualan = () => import(/* webpackPrefetch: true */ '@/views/private/master-penjualan.vue')
const master_penjualan_produk = () => import(/* webpackPrefetch: true */ '@/views/private/master-penjualan/produk/index.vue')
const master_penjualan_paket = () => import(/* webpackPrefetch: true */ '@/views/private/master-penjualan/paket/index.vue')
const master_penjualan_layanan = () => import(/* webpackPrefetch: true */ '@/views/private/master-penjualan/layanan/index.vue')
const master_penjualan_toping = () => import(/* webpackPrefetch: true */ '@/views/private/master-penjualan/topping/index.vue')


const satuan = () => import(/* webpackPrefetch: true */ '@/views/private/master/satuan/index.vue')
const pelanggan = () => import(/* webpackPrefetch: true */ '@/views/private/master/pelanggan/index.vue')
const pelanggan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master/pelanggan/_id.vue')
const type_penjualan = () => import(/* webpackPrefetch: true */ '@/views/private/master/type-penjualan/index.vue')
const bank = () => import(/* webpackPrefetch: true */ '@/views/private/master/bank/index.vue')
const bank_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master/bank/_id.vue')
const banner = () => import(/* webpackPrefetch: true */ '@/views/private/master/banner/index.vue')


const item_sales = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales.vue')
const item_sales_product = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/product/index.vue')
const item_sales_product_add = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/product/add/index.vue')
const item_sales_product_edit = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/product/edit/_id.vue')
const item_sales_product_detail = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/product/_id.vue')
const item_sales_paket = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/paket/index.vue')
const item_sales_paket_add = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/paket/add/index.vue')
const item_sales_paket_edit = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/paket/edit/_id.vue')
const item_sales_paket_detail = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/paket/_id.vue')
const item_sales_layanan = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/layanan/index.vue')
const item_sales_layanan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/item-sales/layanan/_id.vue')

// const pelanggan = () => import(/* webpackPrefetch: true */ '@/views/private/pelanggan/index.vue')


const shift_kasir = () => import(/* webpackPrefetch: true */ '@/views/private/shift-kasir/index.vue')
const shift_kasir_detail = () => import(/* webpackPrefetch: true */ '@/views/private/shift-kasir/_id.vue')

const sales_order = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order.vue')
const sales_order_berlangsung = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/berlangsung/index.vue')
const sales_order_berlangsung_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/berlangsung/_id.vue')
const sales_order_selesai = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/selesai/index.vue')
const sales_order_selesai_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/selesai/_id.vue')
const sales_order_hapus = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/hapus/index.vue')
const sales_order_hapus_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/hapus/_id.vue')
const sales_order_pesanan = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/pesanan/index.vue')
const sales_order_pesanan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/pesanan/_id.vue')
const sales_order_pesanan_ditolak = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/pesanan-ditolak/index.vue')
const sales_order_pesanan_ditolak_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/pesanan-ditolak/_id.vue')
const sales_order_verifikasi_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/verifikasi-pembayaran/index.vue')
const sales_order_verifikasi_pembayaran_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/verifikasi-pembayaran/_id.vue')
const sales_order_transaksi_ditolak = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/transaksi-ditolak/index.vue')
const sales_order_transaksi_ditolak_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales-order/transaksi-ditolak/_id.vue')


const report = () => import(/* webpackPrefetch: true */ '@/views/private/report.vue')
const report_harian = () => import(/* webpackPrefetch: true */ '@/views/private/report/harian/index.vue')
const report_kategori = () => import(/* webpackPrefetch: true */ '@/views/private/report/kategori/index.vue')
const report_metode_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/report/metode-pembayaran/index.vue')
const report_pelanggan = () => import(/* webpackPrefetch: true */ '@/views/private/report/pelanggan/index.vue')
const report_tipe_penjualan = () => import(/* webpackPrefetch: true */ '@/views/private/report/tipe-penjualan/index.vue')
const report_varian = () => import(/* webpackPrefetch: true */ '@/views/private/report/varian/index.vue')
const report_riwayat_transaksi = () => import(/* webpackPrefetch: true */ '@/views/private/report/riwayat-transaksi/index.vue')

// const type_penjualan = () => import(/* webpackPrefetch: true */ '@/views/private/type-penjualan/index.vue')

const konfigurasi = () => import(/* webpackPrefetch: true */ '@/views/private/konfigurasi.vue')
const konfigurasi_import_product = () => import(/* webpackPrefetch: true */ '@/views/private/konfigurasi/import-product/index.vue')
const konfigurasi_outlet = () => import(/* webpackPrefetch: true */ '@/views/private/konfigurasi/outlet/index.vue')
const konfigurasi_profile = () => import(/* webpackPrefetch: true */ '@/views/private/konfigurasi/profile/index.vue')
const konfigurasi_ganti_password = () => import(/* webpackPrefetch: true */ '@/views/private/konfigurasi/ganti-password/index.vue')


const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/perusahaan",
    name: "Perusahaan",
    component: perusahaan,
    meta: {
      title: "Perusahaan"
    }
  },

  {
    path: "/banner",
    name: "Banner",
    component: banner_internal,
    meta: {
      title: "Banner"
    }
  },

  {
    path: "/perusahaan/detail/:id",
    name: "Perusahaan Detail",
    component: perusahaan_detail,
    meta: {
      title: "Perusahaan Detail"
    }
  },

  {
    path: "/outlet",
    name: "Outlet",
    component: outlet,
    meta: {
      title: "Outlet"
    }
  },

  {
    path: "/outlet/detail/:id",
    name: "Outlet Detail",
    component: outlet_detail,
    meta: {
      title: "Outlet Detail"
    }
  },
  
  {
    path: "/jenis-usaha",
    name: "Jenis Usaha",
    component: jenis_usaha,
    meta: {
      title: "Jenis Usaha"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },

  {
    path: "/pilih-outlet",
    name: "Pilih Outlet",
    component: pilit_outlet,
    meta: {
      title: "Pilih Outlet"
    }
  }, 

  {
    path: "/category-user",
    name: "Category User",
    component: category_user,
    meta: {
      title: "Category User"
    }
  },

  {
    path: "/category-user/add",
    name: "Category User Add",
    component: category_user_add,
    meta: {
      title: "Category User Add"
    }
  },

  {
    path: "/category-user/edit/:id",
    name: "Category User Edit",
    component: category_user_edit,
    meta: {
      title: "Category User Edit"
    }
  },

  {
    path: "/user",
    name: "User",
    component: user,
    meta: {
      title: "User"
    }
  },

  {
    path: "/user/detail/:id",
    name: "User Detail",
    component: user_detail,
    meta: {
      title: "User Detail"
    }
  },

  {
    path: "/user/add",
    name: "User Add",
    component: user_add,
    meta: {
      title: "User Add"
    }
  },

  {
    path: "/user/edit/:id",
    name: "User Edit",
    component: user_edit,
    meta: {
      title: "User Edit"
    }
  },

  {
    path: "/member",
    name: "Member",
    component: member,
    meta: {
      title: "Member"
    }
  },

  {
    path: "/member/detail/:id",
    name: "Member E-Katalog Detail",
    component: member_detail,
    meta: {
      title: "Member E-Katalog Detail"
    }
  },

  {
    path: "/master-pembelian",
    name: "pembelian",
    component: master_pembelian,
    meta: {
      title: "Master Pembelian"
    },
    children: [
      {
        path: "/master-pembelian/kategori-item",
        name: "pembelian kategori item",
        component: master_pembelian_kategori_item,
        meta: {
          title: "Master Pembelian Kategori Item"
        }
      },
      {
        path: "/master-pembelian/item",
        name: "pembelian item",
        component: master_pembelian_item,
        meta: {
          title: "Master Pembelian Item"
        }
      },
      {
        path: "/master-pembelian/supplier",
        name: "pembelian supplier",
        component: master_pembelian_supplier,
        meta: {
          title: "Master Pembelian Supplier"
        }
      },
      {
        path: "/master-pembelian/supplier-item",
        name: "pembelian supplier item",
        component: master_pembelian_supplier_item,
        meta: {
          title: "Master Pembelian Supplier Item"
        }
      },
      {
        path: "/master-pembelian/lokasi",
        name: "pembelian lokasi",
        component: master_pembelian_lokasi,
        meta: {
          title: "Master Pembelian Bagian"
        }
      },
      {
        path: "/master-pembelian/satuan",
        name: "pembelian satuan",
        component: master_pembelian_satuan,
        meta: {
          title: "Master Pembelian Satuan"
        } 
      }
    ]
  },

  {
    path: "/master-pembelian/item/add",
    name: "pembelian item add",
    component: master_pembelian_item_add,
    meta: {
      title: "Master Pembelian Item Add"
    }
  },
  {
    path: "/master-pembelian/item/edit/:id",
    name: "pembelian item edit",
    component: master_pembelian_item_edit,
    meta: {
      title: "Master Pembelian Item Edit"
    }
  },
  {
    path: "/master-pembelian/item/detail/:id",
    name: "pembelian item detail",
    component: master_pembelian_item_detail,
    meta: {
      title: "Master Pembelian Item Detail"
    }
  },
  
  {
    path: "/master-pembelian/supplier/add",
    name: "pembelian supplier add",
    component: master_pembelian_supplier_add,
    meta: {
      title: "Master Pembelian Supplier Add"
    }
  },
  {
    path: "/master-pembelian/supplier/edit/:id",
    name: "pembelian supplier edit",
    component: master_pembelian_supplier_edit,
    meta: {
      title: "Master Pembelian Supplier Edit"
    }
  },
  {
    path: "/master-pembelian/supplier/detail/:id",
    name: "pembelian supplier detail",
    component: master_pembelian_supplier_detail,
    meta: {
      title: "Master Pembelian Supplier Detail"
    }
  },
  {
    path: "/master-pembelian/supplier-item/add",
    name: "pembelian supplier item add",
    component: master_pembelian_supplier_item_add,
    meta: {
      title: "Master Pembelian Supplier Item Add"
    }
  },
  {
    path: "/master-pembelian/supplier-item/edit/:id",
    name: "pembelian supplier item edit",
    component: master_pembelian_supplier_item_edit,
    meta: {
      title: "Master Pembelian Supplier Item Edit"
    }
  },
  {
    path: "/master-pembelian/supplier-item/detail/:id",
    name: "pembelian supplier item detail",
    component: master_pembelian_supplier_item_detail,
    meta: {
      title: "Master Pembelian Supplier Item Detail"
    }
  },
  {
    path: "/master-pembelian/lokasi/detail/:id",
    name: "pembelian lokasi detail",
    component: master_pembelian_lokasi_detail,
    meta: {
      title: "Master Pembelian Bagian Detail"
    }
  },
  {
    path: "/master-pembelian/lokasi/edit/:id",
    name: "pembelian lokasi edit",
    component: master_pembelian_lokasi_adit,
    meta: {
      title: "Master Pembelian Bagian Edit"
    }
  },
  {
    path: "/master-pembelian/lokasi/add",
    name: "pembelian lokasi add",
    component: master_pembelian_lokasi_add,
    meta: {
      title: "Master Pembelian Bagian Add"
    }
  },
  {
    path: "/pembelian",
    name: "pembelian",
    component: pembelian,
    meta: {
      title: "Pembelian"
    },
    children: [
      {
        path: "/pembelian/permintaan",
        name: "Permintaan Pembelian",
        component: pembelian_permintaan,
        meta: {
          title: "Permintaan Pembelian"
        }
      },
      {
        path: "/pembelian/approval-permintaan",
        name: "Approval Permintaan Pembelian",
        component: pembelian_approval_permintaan,
        meta: {
          title: "Approval Permintaan Pembelian"
        }
      },
      {
        path: "/pembelian/pengadaan",
        name: "Pengadaan Pembelian",
        component: pembelian_pengadaan,
        meta: {
          title: "Pengadaan Pembelian"
        }
      },
      {
        path: "/pembelian/penerimaan",
        name: "Penerimaan Pembelian",
        component: pembelian_penerimaan,
        meta: {
          title: "Penerimaan Pembelian"
        }
      },
      {
        path: "/pembelian/persediaan",
        name: "Persediaan Pembelian",
        component: pembelian_persediaan,
        meta: {
          title: "Persediaan Pembelian"
        }
      }
    ]
  },

  {
    path: "/pembelian/permintaan/add",
    name: "Permintaan Pembelian Add",
    component: pembelian_permintaan_add,
    meta: {
      title: "Permintaan Pembelian Add"
    }
  },
  {
    path: "/pembelian/permintaan/edit/:id",
    name: "Permintaan Pembelian Edit",
    component: pembelian_permintaan_edit,
    meta: {
      title: "Permintaan Pembelian Edit"
    }
  },
  {
    path: "/pembelian/permintaan/detail/:id",
    name: "Permintaan Pembelian Detail",
    component: pembelian_permintaan_detail,
    meta: {
      title: "Permintaan Pembelian Detail"
    }
  },
  {
    path: "/pembelian/approval-permintaan/detail/:id",
    name: "Permintaan Approval Pembelian Detail",
    component: pembelian_approval_permintaan_detail,
    meta: {
      title: "Detail Approval Permintaan Pembelian"
    }
  },
  {
    path: "/pembelian/permintaan/add_item/:id",
    name: "Permintaan Pembelian Add Item",
    component: pembelian_permintaan_add_item,
    meta: {
      title: "Permintaan Pembelian Add Item"
    }
  },
  {
    path: "/pembelian/pengadaan/add",
    name: "Pengadaan Pembelian Add",
    component: pembelian_pengadaan_add,
    meta: {
      title: "Pengadaan Pembelian Add"
    }
  },
  {
    path: "/pembelian/pengadaan/edit/:id",
    name: "Pengadaan Pembelian Edit",
    component: pembelian_pengadaan_edit,
    meta: {
      title: "Pengadaan Pembelian Edit"
    }
  },
  {
    path: "/pembelian/pengadaan/detail/:id",
    name: "Pengadaan Pembelian Detail",
    component: pembelian_pengadaan_detail,
    meta: {
      title: "Pengadaan Pembelian Detail"
    }
  },
  {
    path: "/pembelian/pengadaan/add_item/:id",
    name: "Pengadaan Pembelian Add Item",
    component: pembelian_pengadaan_add_item,
    meta: {
      title: "Pengadaan Pembelian Add Item"
    }
  },
  {
    path: "/pembelian/pengadaan/invoice/:id",
    name: "Pengadaan Pembelian Invoice",
    component: pembelian_pengadaan_invoice,
    meta: {
      title: "Pengadaan Pembelian Invoice"
    }
  },
  {
    path: "/pembelian/penerimaan/add",
    name: "Penerimaan Pembelian Add",
    component: pembelian_penerimaan_add,
    meta: {
      title: "Penerimaan Pembelian Add"
    }
  },
  {
    path: "/pembelian/penerimaan/edit/:id",
    name: "Penerimaan Pembelian Edit",
    component: pembelian_penerimaan_edit,
    meta: {
      title: "Penerimaan Pembelian Edit"
    }
  },
  {
    path: "/pembelian/penerimaan/detail/:id",
    name: "Penerimaan Pembelian Detail",
    component: pembelian_penerimaan_detail,
    meta: {
      title: "Penerimaan Pembelian Detail"
    }
  },
  {
    path: "/pembelian/penerimaan/add_item/:id",
    name: "Penerimaan Pembelian Add Item",
    component: pembelian_penerimaan_add_item,
    meta: {
      title: "Penerimaan Pembelian Add Item"
    }
  },
  {
    path: "/pembelian/persediaan/add",
    name: "Persediaan Pembelian Add",
    component: pembelian_persediaan_add,
    meta: {
      title: "Persediaan Pembelian Add"
    }
  },
  {
    path: "/pembelian/persediaan/edit/:id",
    name: "Persediaan Pembelian Edit",
    component: pembelian_persediaan_edit,
    meta: {
      title: "Persediaan Pembelian Edit"
    }
  },
  {
    path: "/pembelian/persediaan/detail/:id",
    name: "Persediaan Pembelian Detail",
    component: pembelian_persediaan_detail,
    meta: {
      title: "Persediaan Pembelian Detail"
    }
  },


  {
    path: "/pelanggan",
    name: "Pelanggan",
    component: pelanggan,
    meta: {
      title: "Data Pelanggan"
    }
  },

  {
    path: "/pelanggan/detail/:id",
    name: "Pelanggan Detail",
    component: pelanggan_detail,
    meta: {
      title: "Detail Pelanggan"
    }
  },

  {
    path: "/keuangan",
    name: "Bank",
    component: bank,
    meta: {
      title: "Data keuangan"
    }
  },

  

  {
    path: "/master-penjualan",
    name: "penjualan",
    component: master_penjualan,
    meta: {
      title: "Master Penjualan"
    },
    children: [
      {
        path: "/master-penjualan/produk",
        name: "penjualan produk",
        component: master_penjualan_produk,
        meta: {
          title: "Master Penjualan Produk"
        }
      },
      {
        path: "/master-penjualan/paket",
        name: "penjualan paket",
        component: master_penjualan_paket,
        meta: {
          title: "Master Penjualan Paket"
        }
      },
      {
        path: "/master-penjualan/layanan",
        name: "penjualan layanan",
        component: master_penjualan_layanan,
        meta: {
          title: "Master Penjualan Layanan"
        }
      },
      {
        path: "/master-penjualan/item-penjualan-product",
        name: "Data Produk",
        component: item_sales_product,
        meta: {
          title: "Data Produk"
        }
      },
      {
        path: "/master-penjualan/item-penjualan-topping",
        name: "Data Topping",
        component: master_penjualan_toping,
        meta: {
          title: "Data Topping"
        }
      },
      {
        path: "/master-penjualan/item-penjualan-layanan",
        name: "Data Layanan",
        component: item_sales_layanan,
        meta: {
          title: "Data Layanan"
        }
      },
      {
        path: "/master-penjualan/item-penjualan-paket",
        name: "Data Paket",
        component: item_sales_paket,
        meta: {
          title: "Data Paket"
        }
      },
      {
        path: "/master-penjualan/satuan",
        name: "Satuan",
        component: satuan,
        meta: {
          title: "Data Satuan"
        }
      },
      {
        path: "/master-penjualan/type-penjualan",
        name: "Type Penjualan",
        component: type_penjualan,
        meta: {
          title: "Data Type Penjualan"
        }
      },
      
      {
        path: "/master-penjualan/banner",
        name: "Banner",
        component: banner,
        meta: {
          title: "Data Banner"
        }
      },
    ]
  
  },

  // {
  //   path: "/item-sales",
  //   name: "Item Sales",
  //   component: item_sales,
  //   meta: {
  //     title: "Item Sales"
  //   },
  //   children: [
  //     {
  //       path: "/item-sales/product",
  //       name: "Product",
  //       component: item_sales_product,
  //       meta: {
  //         title: "Product"
  //       }
  //     },
  //     {
  //       path: "/item-sales/paket",
  //       name: "Paket",
  //       component: item_sales_paket,
  //       meta: {
  //         title: "Paket"
  //       }
  //     }
  //   ]
  // },

  {
    path: "/keuangan/detail/:id",
    name: "Detail Keuangan",
    component: bank_detail,
    meta: {
      title: "Detail Keuangan"
    }
  },


  {
    path: "/master-penjualan/product/add",
    name: "Product Add",
    component: item_sales_product_add,
    meta: {
      title: "Tambah Product"
    }
  },

  {
    path: "/master-penjualan/product/edit/:id",
    name: "Product Edit",
    component: item_sales_product_edit,
    meta: {
      title: "Ubah Product"
    }
  },

  {
    path: "/master-penjualan/product/detail/:id",
    name: "Product Detail",
    component: item_sales_product_detail,
    meta: {
      title: "Product Detail"
    }
  },

  {
    path: "/master-penjualan/layanan/detail/:id",
    name: "Layanan Detail",
    component: item_sales_layanan_detail,
    meta: {
      title: "Layanan Detail"
    }
  },
  
  {
    path: "/master-penjualan/item-penjualan-paket/add",
    name: "Paket Add",
    component: item_sales_paket_add,
    meta: {
      title: "Tambah Paket"
    }
  },

  {
    path: "/master-penjualan/item-penjualan-paket/edit/:id",
    name: "Paket Edit",
    component: item_sales_paket_edit,
    meta: {
      title: "Ubah Paket"
    }
  },

  {
    path: "/master-penjualan/item-penjualan-paket/detail/:id",
    name: "Paket Detail",
    component: item_sales_paket_detail,
    meta: {
      title: "Paket Detail"
    }
  },

  // {
  //   path: "/pelanggan",
  //   name: "Pelanggan",
  //   component: pelanggan,
  //   meta: {
  //     title: "Pelanggan"
  //   }
  // },
  
  {
    path: "/shift-kasir",
    name: "Shift Kasir",
    component: shift_kasir,
    meta: {
      title: "Shift Kasir"
    }
  },

  {
    path: "/shift-kasir/detail/:id",
    name: "Shift Kasir Detail",
    component: shift_kasir_detail,
    meta: {
      title: "Shift Kasir Detail"
    }
  },
  
  {
    path: "/sales-order",
    name: "Transaksi",
    component: sales_order,
    meta: {
      title: "Transaksi"
    },
    children: [
      {
        path: "/sales-order/berlangsung",
        name: "Transaksi Berlangsung",
        component: sales_order_berlangsung,
        meta: {
          title: "Transaksi Berlangsung"
        }
      },
      {
        path: "/sales-order/selesai",
        name: "Transaksi Selesai",
        component: sales_order_selesai,
        meta: {
          title: "Transaksi Selesai"
        }
      },
      {
        path: "/sales-order/pesanan",
        name: "Transaksi Pesanan",
        component: sales_order_pesanan,
        meta: {
          title: "Transaksi Pesanan",
        }
      },
      {
        path: "/sales-order/hapus",
        name: "Transaksi Hapus",
        component: sales_order_hapus,
        meta: {
          title: "Transaksi Hapus",
        }
      },
      {
        path: "/sales-order/pesanan-ditolak",
        name: "Transaksi Pesanan Ditolak",
        component: sales_order_pesanan_ditolak,
        meta: {
          title: "Transaksi Pesanan Ditolak",
        }
      },
      {
        path: "/sales-order/verifikasi-pembayaran",
        name: "Transaksi Verifikasi Pembayaran",
        component: sales_order_verifikasi_pembayaran,
        meta: {
          title: "Transaksi Verifikasi Pembayaran",
        }
      },
      {
        path: "/sales-order/transaksi-ditolak",
        name: "Transaksi Ditolak",
        component: sales_order_transaksi_ditolak,
        meta: {
          title: "Transaksi Ditolak",
        }
      }
    ]
  },

  {
    path: "/sales-order/berlangsung/detail/:id",
    name: "Transaksi Berlangsung Detail",
    component: sales_order_berlangsung_detail,
    meta: {
      title: "Transaksi Berlangsung Detail"
    }
  },

  {
    path: "/sales-order/selesai/detail/:id",
    name: "Transaksi Selesai Detail",
    component: sales_order_selesai_detail,
    meta: {
      title: "Transaksi Selesai Detail"
    }
  },

  {
    path: "/sales-order/hapus/detail/:id",
    name: "Transaksi Hapus Detail",
    component: sales_order_hapus_detail,
    meta: {
      title: "Transaksi Hapus Detail"
    }
  },

  {
    path: "/sales-order/pesanan/detail/:id",
    name: "Transaksi Pesanan Detail",
    component: sales_order_pesanan_detail,
    meta: {
      title: "Transaksi Pesanan Detail"
    }
  },
  {
    path: "/sales-order/pesanan-ditolak/detail/:id",
    name: "Transaksi Pesanan Ditolak Detail",
    component: sales_order_pesanan_ditolak_detail,
    meta: {
      title: "Transaksi Pesanan Ditolak Detail"
    }
  },
  
  {
    path: "/sales-order/verifikasi-pembayaran/detail/:id",
    name: "Transaksi Verifikasi Pembayaran Detail",
    component: sales_order_verifikasi_pembayaran_detail,
    meta: {
      title: "Transaksi Verifikasi Pembayaran Detail"
    }
  },
  {
    path: "/sales-order/transaksi-ditolak/detail/:id",
    name: "Transaksi Ditolak Detail",
    component: sales_order_transaksi_ditolak_detail,
    meta: {
      title: "Transaksi Ditolak Detail"
    }
  },
  {
    path: "/report",
    name: "Report",
    component: report,
    meta: {
      title: "Report"
    },
    children: [
      {
        path: "/report/harian",
        name: "Report Harian",
        component: report_harian,
        meta: {
          title: "Report Harian"
        }
      },
      {
        path: "/report/kategori",
        name: "Report Kategori",
        component: report_kategori,
        meta: {
          title: "Report Kategori"
        }
      },
      {
        path: "/report/metode-pembayaran",
        name: "Report Metode Pembayaran",
        component: report_metode_pembayaran,
        meta: {
          title: "Report Metode Pembayaran"
        }
      },
      {
        path: "/report/pelanggan",  
        name: "Report Pelanggan",
        component: report_pelanggan,
        meta: {
          title: "Report Pelanggan"
        }
      },
      {
        path: "/report/tipe-penjualan",
        name: "Report Tipe Penjualan",
        component: report_tipe_penjualan,
        meta: {
          title: "Report Tipe Penjualan"
        }
      },
      {
        path: "/report/varian",
        name: "Report Varian",
        component: report_varian,
        meta: {
          title: "Report Varian"
        }
      },
      {
        path: "/report/riwayat-transaksi",
        name: "Report Riwayat Transaksi",
        component: report_riwayat_transaksi,
        meta: {
          title: "Report Riwayat Transaksi"
        }
      }
    ]
  },

  {
    path: "/konfigurasi",
    name: "konfigurasi",
    component: konfigurasi,
    meta: {
      title: "Konfigurasi"
    },
    children: [
      {
        path: "/konfigurasi/import-product",
        name: "konfigurasi import produk",
        component: konfigurasi_import_product,
        meta: {
          title: "Konfigurasi Import Produk"
        }
      },
      {
        path: "/konfigurasi/outlet",
        name: "konfigurasi outlet",
        component: konfigurasi_outlet,
        meta: {
          title: "Konfigurasi Outlet"
        }
      },
      {
        path: "/konfigurasi/profile",
        name: "konfigurasi profile",
        component: konfigurasi_profile,
        meta: {
          title: "Konfigurasi Profile"
        }
      },
      {
        path: "/konfigurasi/ganti-password",
        name: "konfigurasi ganti password",
        component: konfigurasi_ganti_password,
        meta: {
          title: "Konfigurasi Ganti Password"
        }
      }
    ]
  },

  // {
  //   path: "/type-penjualan",
  //   name: "Type Penjualan",
  //   component: type_penjualan,
  //   meta: {
  //     title: "Type Penjualan"
  //   }
  // }

  
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})